<template>
  <v-flex>
    <!-- Formulario para crear o editar una punto -->
    <v-dialog v-if="this.modelPunto" v-model="dialogFormularioPunto" :max-width="900" persistent>
      <punto-formulario @cerrarFormularioPunto="dialogFormularioPunto = false" :modelPunto="this.modelPunto"
        :accion="this.accionPunto" />
    </v-dialog>

    <!-- Formulario para crear o editar un proveedor -->
    <v-dialog v-if="this.modelProveedor" v-model="dialogFormularioProveedor" :max-width="1400" persistent>
      <proveedor-formulario @cerrarFormularioProveedor="dialogFormularioProveedor = false"
        :modelProveedor="this.modelProveedor" :accion="this.accionProveedor" />
    </v-dialog>

    <!-- Confirmación de eliminación de punto -->
    <v-dialog v-model="showConfirmacionEliminacionPunto" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacionPunto = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar este punto? <br><br>
              Se eliminarán todos los proveedores asociados a este punto.
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarPunto()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacionPunto = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirmación de eliminación de proveedor -->
    <v-dialog v-model="showConfirmacionEliminacionProveedor" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'"
            @click="showConfirmacionEliminacionProveedor = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el proveedor?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarProveedor()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3"
              @click="showConfirmacionEliminacionProveedor = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Alojamientos por Puntos</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <!--  <v-chip label class="mr-2" link :color="'green lighten-1'" @click="mostrarOrdenamientos = !mostrarOrdenamientos">
          <h5 v-bind:style="{ color: 'white' }">
           {{ mostrarOrdenamientos? 'DESHABILITAR ORDENAMIENTOS': 'HABILITAR ORDENAMIENTOS'}} 
          </h5>
        </v-chip> -->

        <v-chip label class="mr-2" link :color="'green lighten-1'" @click="_desplegarTodos()">
          <span v-bind:style="{ color: 'white' }">
            Desplegar/Ocultar Todos
          </span>
        </v-chip>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearPunto">
          <span v-bind:style="{ color: 'white' }">
            Nuevo Punto
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaNombre" autocomplete="off"
              label="Búsqueda" placeholder="Busqueda por nombre" @keyup="changeBusqueda" dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">

          </v-col>
          <v-col cols="4" align="start">

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>

        <v-card v-for="punto in puntos" :key="punto.id" class="mb-2" color="rgb(250, 250, 250)">
          <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
            <v-chip label link class="mr-1" color="rgb(60, 60, 60)" @click="_changeShowHidePunto(punto.id)">
              <span v-bind:style="{ color: 'white' }">
                {{ punto && punto.proveedores ? punto.proveedores.length : '0' }} Alojamientos
              </span>
            </v-chip>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-toolbar-title :dark="!dark">{{ punto.nombre }}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-chip label class="mr-2" link :color="colorAccent1" @click="_crearProveedor(punto)">
              <span v-bind:style="{ color: 'white' }">
                Nuevo Alojamiento
              </span>
            </v-chip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link :color="colorAccent3" @click="_editarPunto(punto)" v-on="on">
                  <v-icon color="white">mdi-pencil</v-icon>
                </v-chip>
              </template>
              <span>Editar Punto</span>
            </v-tooltip>
          <!--  <v-tooltip v-if="punto.proveedores.length == 0" bottom>
              <template v-slot:activator="{ on }">
                <v-chip label class="mr-1 px-1" link color="red lighten-2" @click="_deletePunto(punto)" v-on="on">
                  <v-icon color="white">mdi-delete</v-icon>
                </v-chip>
              </template>
              <span>Eliminar Punto</span>
            </v-tooltip> -->
          </v-toolbar>
          <v-card-text>
            <v-card v-if="!punto.hide" class="mb-1 elevation-0" v-for="proveedor in punto.proveedores"
              :key="proveedor.id" color="rgb(230, 230, 230)">
              <v-card-text>
                <v-row>
                  <span class="ml-1 mt-1 mb-1">
                    {{ proveedor.nombre_alias }}
                  </span>


                  <v-spacer></v-spacer>


                  <v-chip
                    v-if="mostrarOrdenamientos && (punto.proveedores.length > 0 && proveedor.id == punto.proveedores[0].id)"
                    label class="mr-1 px-1" color="transparent">
                    <v-icon color="transparent">mdi-arrow-up-bold</v-icon>
                  </v-chip>
                  <v-chip v-if="mostrarOrdenamientos && (proveedor.id != punto.proveedores[0].id)" label
                    class="mr-1 px-1" link color="green lighten-1" @click="">
                    <v-icon color="white">mdi-arrow-up-bold</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="mostrarOrdenamientos && (punto.proveedores.length > 0 && proveedor.id == punto.proveedores[punto.proveedores.length - 1].id)"
                    label class="mr-4 px-1" color="transparent">
                    <v-icon color="transparent">mdi-arrow-down-bold</v-icon>
                  </v-chip>
                  <v-chip
                    v-if="mostrarOrdenamientos && proveedor.id != punto.proveedores[punto.proveedores.length - 1].id"
                    label class="mr-4 px-1" link color="green lighten-1" @click="">
                    <v-icon color="white">mdi-arrow-down-bold</v-icon>
                  </v-chip>
                  <v-chip label small class="mr-1 mt-1 mb-1" link :color="colorAccent3"
                    @click="_editarProveedor(proveedor)" text-color="white">
                    Editar
                  </v-chip>
                  <v-chip label small class="mr-1 mt-1 mb-1" link color="red lighten-2"
                    @click="_deleteProveedor(proveedor)" text-color="white">
                    Eliminar
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import PuntoFormulario from "../components/formularios/PuntoFormulario";
import ProveedorFormulario from "../components/formularios/ProveedorFormulario";

export default {
  components: {
    PuntoFormulario, ProveedorFormulario
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    accionPunto: "",
    accionProveedor: "",

    dialogFormularioPunto: false,
    modelPunto: null,
    showConfirmacionEliminacionPunto: false,

    dialogFormularioProveedor: false,
    modelProveedor: null,
    showConfirmacionEliminacionProveedor: false,
    mostrarOrdenamientos: false,

    desplegado: false,

  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorBarraFormularioSecundario",
      "colorFondo300",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("puntos", ["puntos", "puntoSelec"]),
    ...mapState("proveedores", ["proveedores", "proveedorSelec"]),

  },

  watch: {},

  mounted() {
    this._getPuntos(true);
  },

  methods: {
    ...mapActions("puntos", ["getPuntos", "eliminarPunto", "updatePunto"]),
    ...mapMutations("puntos", ["setPuntoSelec"]),
    ...mapActions("proveedores", ["getProveedores", "eliminarProveedor", "updateProveedor"]),
    ...mapMutations("proveedores", ["setProveedorSelec"]),

    changeBusqueda(event) { },

    _inicializarModelPunto() {
      this.modelPunto = {
        id: null,
        nombre: null,
        provincia: null,
        descripcion: null,
        localizacion: null,
        avatar: null,
      };
    },

    _inicializarModelProveedor(punto_id) {
      this.modelProveedor = {
        id: null,
        nombre: null,
        nombre_alias: null,
        cif: null,
        tipo: null,

        categoriaProveedor: null,
        punto: null,

        categoria_proveedor_id: null,
        punto_id: punto_id,
        
        contacto: null,
        telefono: null,
        email: null,
        contactos: [],
        venta_libre: false,
        venta_libre_canthabitaciones: null,
        contacto: null,

        localizacion: null,
        direccion: null,
        codigo_postal: null,
        poblacion: null,
        provincia: null,
        pais: null,

        direccion_fiscal: null,
        codigo_postal_fiscal: null,
        poblacion_fiscal: null,
        provincia_fiscal: null,
        pais_fiscal: null,
        alias_bono: null,
        direccion_bono: null,
        observaciones_bono: null,
        cod_postal_bono: null,
        poblacion_bono: null,
        telefono_bono: null,
        banco_iban: null,
        prepago_dias: null,
        prepago_tipo_dias: null,

        observatorios: null,

        deshabilitado: false,
        comisiones_iva_incluido: false,
        retener_irpf: false,

        ofrecen_cena: false,
        ofrecen_cena_terceros: false,
        picnic_tarifa: null,
        picnic_descripcion_ES: null,
        picnic_descripcion_EN: null,
        picnic_descripcion_DE: null,
        cena_terceros_descripcion_ES: null,
        cena_terceros_descripcion_EN: null,
        cena_terceros_descripcion_DE: null,
        mascotas: false,
        request_tipo: null,
        request_automatico: null,

      };
    },

    _imprimir() { },

    async _getPuntos(showload) {
      await this.getPuntos([this.access_token, showload]);
    },

    _deletePunto(item) {
      this.setPuntoSelec(item);
      this.showConfirmacionEliminacionPunto = true;
    },

    _deleteProveedor(item) {
      this.setProveedorSelec(item);
      this.showConfirmacionEliminacionProveedor = true;
    },

    _crearPunto() {
      this._inicializarModelPunto();
      this.accionPunto = 'crear';
      this.dialogFormularioPunto = true;
    },

    _crearProveedor(punto) {
      this._inicializarModelProveedor(punto.id);
      this.accionProveedor = 'crear';
      this.dialogFormularioProveedor = true;
    },

    _editarPunto(item) {
      this.setPuntoSelec(item);
      let temp = JSON.parse(JSON.stringify(this.puntoSelec));
      this.modelPunto = temp;
      this.accionPunto = 'editar';
      this.dialogFormularioPunto = true;
    },

    _desplegarTodos() {
      this.puntos.forEach(punto => {
        punto.hide = false;
      });
    },

    _changeShowHidePunto(id) {
      let punto = this.puntos.find(p => p.id == id);
      punto.hide = !punto.hide;
    },

    _editarProveedor(item) {
      this.setProveedorSelec(item);
      let temp = JSON.parse(JSON.stringify(this.proveedorSelec));
      this.modelProveedor = temp;
      this.accionProveedor = 'editar';
      this.dialogFormularioProveedor = true;
    },

    async _eliminarPunto() {
      this.showConfirmacionEliminacionPunto = false;
      if (this.puntoSelec != null) {
        await this.eliminarPunto([this.access_token, this.puntoSelec.id]);
      }
    },

    async _eliminarProveedor() {
      this.showConfirmacionEliminacionProveedor = false;
      if (this.proveedorSelec != null) {
        await this.eliminarProveedor([this.access_token, this.proveedorSelec.id]);
      }
    },
  },
};
</script>
